module.exports = __webpack_public_path__ + "static/media/sea_bench.c9c5e2d6.JPG";